export class Utils {
  static isNull(obj: any): boolean {
    return obj === null;
  }

  static isUndefined(obj: any): boolean {
    return typeof obj === 'undefined';
  }
}
